<div class="filters-container">
  <form [formGroup]="searchForm" class="search-form">
    <ion-icon name="search-outline" class="search-icon"></ion-icon>
    <input class="search-input" formControlName="search" placeholder="Imię, nazwisko, email, userId, nr tel..." />
  </form>
</div>
